import React from 'react';

const Separator = () => (
	<div style={{ marginTop: '0.5rem', marginBottom: '0.5rem', width: '100%' }}>
		<div style={{ overflow: 'hidden', textAlign: 'center' }}>
			<span className="orSpan">
					or
			</span>
		</div>
	</div>
);

export default Separator;
